

import axios from "axios";

const getAuthToken = () => JSON.parse(localStorage.getItem("token"));

const sanitizeCountry = (code) => {
  if (!code || code === "undefined" || code === "null") {
    return "";
  }
  return code;
};

const { REACT_APP_LOGIN_API_BASEURL } = process.env;

export const getCartItems = async () => {
  try {
    const response = await axios.get(`${REACT_APP_LOGIN_API_BASEURL}/v2/cart`, {
      headers: { Authorization: `Bearer ${getAuthToken()}` },
    });
    return response.data.data;
  } catch (error) {
    console.error("getCartItems error:", error.message);
    return null;
  }
};

export const addCartItem = async (item, coupon, latitude, longitude, countryCode, bundle, courseName) => {
  try {
    const payload = {
      courses: item.courses || [],
      courseName,
      coupon: coupon || null,
    };
    const response = await axios.post(
      `${REACT_APP_LOGIN_API_BASEURL}/v2/cart?country=${sanitizeCountry(countryCode)}`,
      payload,
      {
        headers: {
          Authorization: `Bearer ${getAuthToken()}`,
          "Content-Type": "application/json",
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("addCartItem error:", error.message);
    return null;
  }
};

export const addCartItemOffLine = async (item, countryCode) => {
  try {
    const response = await axios.post(
      `${REACT_APP_LOGIN_API_BASEURL}/v2/cart?country=${sanitizeCountry(countryCode)}`,
      item,
      {
        headers: {
          Authorization: `Bearer ${getAuthToken()}`,
          "Content-Type": "application/json",
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("addCartItemOffLine error:", error.message);
    return null;
  }
};

export const updateCartService = async (item, countryCode) => {
  try {
    const response = await axios.put(
      `${REACT_APP_LOGIN_API_BASEURL}/v2/cart/${item}?country=${sanitizeCountry(countryCode)}`,
      null,
      {
        headers: { Authorization: `Bearer ${getAuthToken()}` },
      }
    );
    return response.data;
  } catch (error) {
    console.error("updateCartService error:", error.message);
    return null;
  }
};

export const removeCartService = async (item, countryCode) => {
  try {
    const response = await axios.delete(
      `${REACT_APP_LOGIN_API_BASEURL}/v2/cart/${item}?country=${sanitizeCountry(countryCode)}`,
      {
        headers: { Authorization: `Bearer ${getAuthToken()}` },
      }
    );
    return response.data;
  } catch (error) {
    console.error("removeCartService error:", error.message);
    return null;
  }
};

export const clearCartService = async () => {
  try {
    const response = await axios.delete(`${REACT_APP_LOGIN_API_BASEURL}/v2/cart`, {
      headers: {
        Authorization: `Bearer ${getAuthToken()}`,
        "Content-Type": "application/json",
      },
    });
    return response.data;
  } catch (error) {
    console.error("clearCartService error:", error.message);
    return null;
  }
};

export const makePaymentService = async (items) => {
  try {
    const response = await axios.post(
      `${REACT_APP_LOGIN_API_BASEURL}/make-payment`,
      { courseList: items },
      {
        headers: {
          Authorization: `Bearer ${getAuthToken()}`,
          "Content-Type": "application/json",
        },
      }
    );
    return response.data.data;
  } catch (error) {
    console.error("makePaymentService error:", error.message);
    return null;
  }
};

export const chargeCardService = async (token, sessionId, enterpriseStatus, changedSelectedPlan) => {
  try {
    let url = enterpriseStatus
      ? `${REACT_APP_LOGIN_API_BASEURL}/charge-card-token`
      : `${REACT_APP_LOGIN_API_BASEURL}/charge-card-token`;

    const testDemoPlan = localStorage.getItem("Demo Plan");

    const testPlan = () => {
      if (testDemoPlan === "demo Plan") {
        return { token: token, testmode: "on" };
      } else {
        return { token: token };
      }
    };

    const payload = enterpriseStatus
      ? changedSelectedPlan !== null
        ? { token: token, selectedPlan: changedSelectedPlan }
        : testPlan()
      : { token: token, sessionId: sessionId };

    const response = await axios.post(url, payload, {
      headers: {
        Authorization: `Bearer ${getAuthToken()}`,
        "Content-Type": "application/json",
      },
    });
    return response.data;
  } catch (error) {
    console.error("chargeCardService error:", error.message);
    return null;
  }
};

export const verifyCheckoutService = async (sessionId, countryCode, enterpriseStatus, paymentId) => {
  try {
    let url = enterpriseStatus
      ? `${REACT_APP_LOGIN_API_BASEURL}/razorpay-checkout`
      : `${REACT_APP_LOGIN_API_BASEURL}/v2/checkout?country=${countryCode}`;

    const payload = enterpriseStatus
      ? { id: sessionId, payment_id: paymentId }
      : { sessionId: sessionId, payment_id: paymentId };

    const response = await axios.post(url, payload, {
      headers: {
        Authorization: `Bearer ${getAuthToken()}`,
        "Content-Type": "application/json",
      },
    });
    return response.data;
  } catch (error) {
    console.error("verifyCheckoutService error:", error.message);
    return null;
  }
};

export const applyCoupon = async (promoCode, courseId, countryCode) => {
  try {
    const response = await axios.post(
      `${REACT_APP_LOGIN_API_BASEURL}/promoCode?country=${sanitizeCountry(countryCode)}`,
      { coupon: promoCode, courseId: courseId },
      {
        headers: {
          Authorization: `Bearer ${getAuthToken()}`,
          "Content-Type": "application/json",
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("applyCoupon error:", error.message);
    return null;
  }
};

export const handlePostWishlist = async (courseId) => {
  try {
    const response = await axios.post(
      `${REACT_APP_LOGIN_API_BASEURL}/wishlist/${courseId}`,
      { courseId: courseId },
      {
        headers: {
          Authorization: `Bearer ${getAuthToken()}`,
          "Content-Type": "application/json",
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("handlePostWishlist error:", error.message);
    return null;
  }
};

export const getWishlist = async () => {
  try {
    const response = await axios.get(`${REACT_APP_LOGIN_API_BASEURL}/wishlist`, {
      headers: {
        Authorization: `Bearer ${getAuthToken()}`,
      },
    });
    return response.data.data;
  } catch (error) {
    console.error("getWishlist error:", error.message);
    return [];
  }
};

export const handleDeleteWishlist = async (courseId) => {
  try {
    const response = await axios.delete(`${REACT_APP_LOGIN_API_BASEURL}/wishlist/${courseId}`, {
      headers: {
        Authorization: `Bearer ${getAuthToken()}`,
      },
    });
    return response.data.data;
  } catch (error) {
    console.error("handleDeleteWishlist error:", error.message);
    return null;
  }
};
